var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('form',{staticClass:"form",on:{"submit":function($event){$event.preventDefault();return _vm.saveData.apply(null, arguments)}}},[_c('vs-button',{staticClass:"button",attrs:{"loading":_vm.waiting}},[_vm._v("Guardar")])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h4',{staticStyle:{"padding":"1rem 3rem"}},[_c('b',[_vm._v("Credenciales para Nomina Electronica")])])
}]

export { render, staticRenderFns }